import { action, observable } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { JobScopeChange } from '@/features/jobs/job-scope-changes/JobScopeChange'

/**
 * View Model for viewing a scope change request.
 */
export class ViewJobScopeChangeRequestDialogViewModel {
  /**
   * The dialog's modal state.
   */
  readonly modal = new ModalViewModel()

  /**
   * The request being viewed.
   */
  @observable accessor scopeChangeRequest = JobScopeChange.none

  /**
   * Shows the request.
   */
  @action.bound
  show(scopeChangeRequest: JobScopeChange) {
    this.scopeChangeRequest = scopeChangeRequest
    this.modal.show()
  }
}
